import { useLang } from "../i18n/LangContext";

// Unicode regional-indicator flags are rendered as emoji by the OS.
// BR / US / ES covers PT-BR, EN and ES — matches our LangContext codes.
const OPTIONS = [
  { code: "pt", flag: "🇧🇷", label: "PT" },
  { code: "en", flag: "🇺🇸", label: "EN" },
  { code: "es", flag: "🇪🇸", label: "ES" },
];

/**
 * Compact flag-based language picker — lets the user pick any of the 3 languages
 * directly (vs. LangToggle which cycles). Used on the public Login/Signup page.
 */
export default function LangFlags({ className = "", testid = "login-lang-flags" }) {
  const { lang, setLang } = useLang();
  return (
    <div data-testid={testid} className={`inline-flex items-center gap-1 p-1 rounded-full border bg-white/80 backdrop-blur ${className}`}
      style={{ borderColor: "#E5E2DA" }}>
      {OPTIONS.map(({ code, flag, label }) => {
        const active = lang === code;
        return (
          <button
            key={code}
            type="button"
            onClick={() => setLang(code)}
            data-testid={`lang-flag-${code}`}
            title={label}
            aria-pressed={active}
            className={`inline-flex items-center gap-1.5 h-8 px-2.5 rounded-full text-[11.5px] font-semibold transition-all ${
              active
                ? "bg-[#0A1233] text-white shadow-sm"
                : "text-[#475569] hover:bg-[#F5F2EA]"
            }`}
          >
            <span className="text-[15px] leading-none">{flag}</span>
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
